<template>
    <form class="form">
        <slot />
    </form>
</template>

<script>

export default {

}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\global\forms\_hh-form.scss

.form {
    width: 100%;
    @include clear-after;

    @include element('field') {
        width: 100%;
    }
}

</style>
